/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rapid_Eager_Otter_NodInputs */

const fr_rapid_eager_otter_nod = /** @type {(inputs: Rapid_Eager_Otter_NodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`mois`)
};

/**

* @param {Rapid_Eager_Otter_NodInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const rapid_eager_otter_nod = /** @type {((inputs?: Rapid_Eager_Otter_NodInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rapid_Eager_Otter_NodInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_rapid_eager_otter_nod(inputs)
});